$(document).ready(function() {
    $("#google-maps-form").on('submit', function (e) {
        e.preventDefault();
        var startAddress = encodeURI($('input[name="street"]').val() + ' ' + $('input[name="zipcity"]').val());
        var dealerAddress = encodeURI($('input[name="dealerAddress"]').val() + ' ' + $('input[name="dealerPostalCode"]').val() + ' ' + $('input[name="dealerLocation"]').val());

        window.open('https://www.google.de/maps/dir/' + startAddress + '/' + dealerAddress);
    });
});